export const trackingData = {
  tracking: [
    {
      android_version: "13",
      app_version: "1.0",
      brand: "realme",
      device_id: "1ab01051e1778a5b",
      formatted_date: "24 Nov 2025, 08:17 AM",
      model: "RMX3081",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "d9OJj00OD0YeDdTjnR0e3QnOuz03",
    },
    {
      android_version: "11",
      app_version: "1.0",
      brand: "Redmi",
      device_id: "57d6378b4b60d142",
      formatted_date: "24 Nov 2025, 06:20 AM",
      model: "Redmi Note 8 Pro",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "Fg92aCcZq6Z5LwIMJDzk5BfcbJv2",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "google",
      device_id: "e5235ca0927aef7f",
      formatted_date: "20 Nov 2025, 10:34 AM",
      model: "sdk_gphone64_arm64",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "7p2iezVkQAYJ8j6A3giIhyJ5Uvp1",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "motorola",
      device_id: "7f7fac6d34c32dfd",
      formatted_date: "20 Nov 2025, 08:15 AM",
      model: "motorola edge 50 pro",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "google",
      device_id: "4817158579a78d48",
      formatted_date: "20 Nov 2025, 07:54 AM",
      model: "sdk_gphone64_arm64",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "",
    },
    {
      android_version: "15",
      app_version: "1.0",
      brand: "samsung",
      device_id: "33a634a944b9814c",
      formatted_date: "17 Nov 2025, 09:29 AM",
      model: "SM-S721B",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "MwPwExw1N3VoVuFraJL80m9h1L42",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "motorola",
      device_id: "edec83d0ba668fa4",
      formatted_date: "13 Nov 2025, 05:25 AM",
      model: "motorola edge 50 pro",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "SrKNAlPfQYeRZaQefUxRc6Bvy1Y2",
    },
    {
      android_version: "13",
      app_version: "1.0",
      brand: "realme",
      device_id: "1ab01051e1778a5b",
      formatted_date: "24 Nov 2025, 08:17 AM",
      model: "RMX3081",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "d9OJj00OD0YeDdTjnR0e3QnOuz03",
    },
    {
      android_version: "11",
      app_version: "1.0",
      brand: "Redmi",
      device_id: "57d6378b4b60d142",
      formatted_date: "24 Nov 2025, 06:20 AM",
      model: "Redmi Note 8 Pro",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "Fg92aCcZq6Z5LwIMJDzk5BfcbJv2",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "google",
      device_id: "e5235ca0927aef7f",
      formatted_date: "20 Nov 2025, 10:34 AM",
      model: "sdk_gphone64_arm64",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "7p2iezVkQAYJ8j6A3giIhyJ5Uvp1",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "motorola",
      device_id: "7f7fac6d34c32dfd",
      formatted_date: "20 Nov 2025, 08:15 AM",
      model: "motorola edge 50 pro",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "google",
      device_id: "4817158579a78d48",
      formatted_date: "20 Nov 2025, 07:54 AM",
      model: "sdk_gphone64_arm64",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "",
    },
    {
      android_version: "15",
      app_version: "1.0",
      brand: "samsung",
      device_id: "33a634a944b9814c",
      formatted_date: "17 Nov 2025, 09:29 AM",
      model: "SM-S721B",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "MwPwExw1N3VoVuFraJL80m9h1L42",
    },
    {
      android_version: "16",
      app_version: "1.0",
      brand: "motorola",
      device_id: "edec83d0ba668fa4",
      formatted_date: "13 Nov 2025, 05:25 AM",
      model: "motorola edge 50 pro",
      utm_raw: "utm_source=google-play&utm_medium=organic",
      utm_source: "google-play",
      uuid: "SrKNAlPfQYeRZaQefUxRc6Bvy1Y2",
    },
  ],
  totalRows: "7",
};
